import { Component, ElementRef, Input, OnInit, ViewChild, Output, EventEmitter } from '@angular/core';
import { Router } from '@angular/router';
import { AuthService } from '../../access/auth.service';
import { ModalService } from '../../util/modal.service';
import { RedirectRuleDto } from '../../models/search-redirectRules';



@Component({
  selector: 'redirect-table',
  templateUrl: './redirect-table.component.html',
  styleUrls: ['./redirect-table.component.scss']
})
export class RedirectTableComponent implements OnInit {
  @ViewChild('modal', { static: true }) modal!: ElementRef<HTMLDivElement>;
  @Input() redirect: any = [];
  @Input() isColaborator: boolean | undefined;
  @Input() isManager: boolean | undefined;
  @Input() subsidiary: any;
  @Input() actualSearch: any;
  @Input() selectedRedirect: RedirectRuleDto | undefined
  @Output() requestDelete = new EventEmitter<RedirectRuleDto>();
  private storeId: string = '';

  constructor(
    private _route: Router,
    private _auth: AuthService,
    private _modalService: ModalService,
  ) { }

  ngOnInit(): void {
    if(this._auth.getStore()) {
      this.storeId = this._auth.getStore().storeId;
    }
  }
  editar(redirect: RedirectRuleDto) {
    this._route.navigate(['/members/search-redirect/detailRedirect', redirect.id])
  }

  toggleOptions(e: HTMLImageElement | null) {
    // @ts-ignore
    let div: HTMLElement = e.parentElement
    if (div.classList.contains('options')) {
      // @ts-ignore
      div.querySelector('.box').classList.toggle('d-none')
    }

  }
  
  onDeleteClick(item: RedirectRuleDto): void {
    this.requestDelete.emit(item);
  }
  error(err: any) {
    if (err.error.detail) {
      this._modalService.showModalError('Ocurrio un error', err.error.detail.text)
    } else {
      this._modalService.showModalGenerico()
    }
  }

}
